<template>
    <div class="sustainability-has">
        <p class="indent">The health and safety of each and every individual working on the premises of Alcomet is our highest priority. We make no compromises when it comes to protecting human life and preventing injuries. A thorough risk assessment is made for every workplace and updated regularly with particular focus on potential hazards and prevention measures.  All employees and contract workers undergo regular training to enhance their understanding of the safety regulations set by the company. We make sure that all available engineering decisions, new technologies and best practices are put in place to offer best possible protection to people working on the territory of Alcomet. Internal investigations are routinely conducted after any incident to identify the causes and eliminate the risk for recurrences.</p>
        <p class="indent">The Health and Safety policy of the company is based on the Occupational Health and Safety Management certificate ISO 45001:2018  acquired by Alcomet in 2019.</p>
        <p>
          <a href="/static/files/A-POLICY-FOR-HEALTHY-AND-SAFE-LABOUR-CONDITIONS.pdf" target="_blank">A POLICY FOR HEALTHY AND SAFE LABOUR CONDITIONS</a>
        </p>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.sustainability-has > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-has {
    padding-bottom: 20px;
  }
  .sustainability-has > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/HealthAndSafety.vue